import { render, staticRenderFns } from "./base-icon.vue?vue&type=template&id=3a6db8f2&functional=true&"
import script from "./base-icon.vue?vue&type=script&lang=js&"
export * from "./base-icon.vue?vue&type=script&lang=js&"
import style0 from "./base-icon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports